if (!customElements.get('glowe-complete-set')) {
  customElements.define('glowe-complete-set', class extends HTMLElement {
    connectedCallback() {
      this.data = JSON.parse(this.querySelector('[data-set-product]').textContent);
      this.defaultButtonLabel = this.querySelector('[data-set-open]').textContent;
      this.dialog = this.querySelector('[data-set-dialog]');
      this.form = this.closest('.shopify-section')?.querySelector('product-form-component[data-product-id]');
      this.stateKey = `${location.pathname}:${this.dataset.sectionId}`;
      window.gloweCompleteSetSelections ||= new Map();
      this.colour = null;
      this.charm = null;
      this.selected = this.data.variants.find(v => v.id === window.gloweCompleteSetSelections.get(this.stateKey) && v.available) || null;
      this.querySelector('[data-set-open]').addEventListener('click', () => this.dialog.showModal());
      this.querySelector('[data-set-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.dialog.close(); });
      this.querySelector('[data-set-remove]').addEventListener('click', () => { this.selected = null; window.gloweCompleteSetSelections.delete(this.stateKey); this.updateCard(); });
      this.querySelector('[data-set-confirm]').addEventListener('click', () => {
        const variant = this.resolve();
        if (!variant?.available) return;
        this.selected = variant;
        window.gloweCompleteSetSelections.set(this.stateKey, variant.id);
        this.updateCard();
        this.dialog.close();
      });
      this.renderColours();
      this.renderCharms();
      this.updateCard();
      this.observeVariant();
    }

    money(cents) {
      const currency = this.data.currency || window.Shopify?.currency?.active || 'USD';
      return new Intl.NumberFormat(this.data.locale || document.documentElement.lang || 'en', { style: 'currency', currency }).format(cents / 100);
    }

    resolve() {
      return this.data.variants.find(v => v.colour === this.colour && v.charm === this.charm);
    }

    renderColours() {
      const root = this.querySelector('[data-set-colours]');
      root.replaceChildren(...this.data.colours.map(colour => {
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = colour;
        button.setAttribute('aria-pressed', String(this.colour === colour));
        button.addEventListener('click', () => {
          this.colour = colour;
          if (!this.resolve()?.available) this.charm = null;
          this.renderColours();
          this.renderCharms();
          this.updateSummary();
        });
        return button;
      }));
    }

    renderCharms() {
      const root = this.querySelector('[data-set-charms]');
      root.replaceChildren(...this.data.charms.map(charm => {
        const variant = this.data.variants.find(v => v.colour === this.colour && v.charm === charm);
        const image = variant?.image || this.data.variants.find(v => v.charm === charm)?.image;
        const button = document.createElement('button');
        button.type = 'button';
        button.disabled = !variant?.available;
        button.setAttribute('aria-pressed', String(this.charm === charm));
        if (image) {
          const img = document.createElement('img');
          img.src = image;
          img.alt = '';
          img.loading = 'lazy';
          button.append(img);
        }
        const label = document.createElement('span');
        label.textContent = charm;
        button.append(label);
        if (this.colour && !variant?.available) {
          const sold = document.createElement('small');
          sold.textContent = 'Sold out';
          button.append(sold);
        }
        button.addEventListener('click', () => { this.charm = charm; this.renderCharms(); this.updateSummary(); });
        return button;
      }));
    }

    updateSummary() {
      const variant = this.resolve();
      this.querySelector('[data-set-summary]').textContent = variant ? `${this.colour} Leash · ${this.charm}` : 'Choose a colour and charm';
      this.querySelector('[data-set-summary-price]').textContent = variant ? `+${this.money(variant.price)}` : '';
      this.querySelector('[data-set-confirm]').disabled = !variant?.available;
    }

    collarPrice() {
      const id = Number(this.form?.querySelector('input[name="id"]')?.value);
      return this.data.collarVariants.find(v => v.id === id)?.price ?? Number(this.dataset.collarPrice);
    }

    observeVariant() {
      const input = this.form?.querySelector('input[name="id"]');
      if (!input) return;
      this.observer = new MutationObserver(() => this.updateCard());
      this.observer.observe(input, { attributes: true, attributeFilter: ['value'] });
      this.form.addEventListener('change', () => requestAnimationFrame(() => this.updateCard()));
    }

    disconnectedCallback() { this.observer?.disconnect(); }

    updateCard() {
      const selected = this.selected;
      if (this.form) {
        if (selected) this.form.dataset.completeSetVariantId = selected.id;
        else delete this.form.dataset.completeSetVariantId;
      }
      this.querySelector('[data-set-heading]').textContent = `${selected ? '✓ ' : ''}COMPLETE THE SET`;
      this.querySelector('[data-set-helper]').hidden = Boolean(selected);
      this.querySelector('[data-set-choice]').hidden = !selected;
      this.querySelector('[data-set-price]').hidden = !selected;
      this.querySelector('[data-set-remove]').hidden = !selected;
      this.querySelector('[data-set-totals]').hidden = !selected;
      this.querySelector('[data-set-checkout-note]').hidden = !selected;
      this.querySelector('[data-set-open]').textContent = selected ? 'CHANGE' : this.defaultButtonLabel;
      if (selected) {
        const collarPrice = this.collarPrice();
        this.querySelector('[data-set-choice]').textContent = `${selected.colour} Leash · ${selected.charm}`;
        this.querySelector('[data-set-price]').textContent = `+${this.money(selected.price)}`;
        this.querySelector('[data-set-collar-price]').textContent = this.money(collarPrice);
        this.querySelector('[data-set-leash-price]').textContent = `+${this.money(selected.price)}`;
        this.querySelector('[data-set-total]').textContent = this.money(collarPrice + selected.price);
      }
      const checkout = this.closest('.shopify-section')?.querySelector('.buy-buttons-block shopify-accelerated-checkout, .buy-buttons-block .shopify-payment-button');
      if (checkout) checkout.hidden = Boolean(selected);
    }
  });
}
